import React from 'react';
import classNames from 'classnames'
import { Table } from 'components/composite';
import { ReactComponent as Cross } from 'assets/icons/cross.svg';
import { ReactComponent as Tick } from 'assets/icons/tick.svg';
import { ReactComponent as Chevron } from 'assets/icons/chevron.svg';

function Airlines({ airlines }) {
	const airlinesList = airlines;
	const pathName = window.location.pathname;
	
	if(pathName.toLowerCase() === '/travelsafe' || pathName.toLowerCase() === '/travelsafe/' || pathName.toLowerCase() === '/travelsafe/flipkart' || pathName.toLowerCase() === '/travelsafe/flipkart/') {
		return (
			<>
			<Table>
				<Table.Head className='bg-neutral-0 c-neutral-700 fs-2 mb-2 flex flex-middle d-none--xs'>
					<Table.Column span={4} className='py-2 pl-4'>
						Airline
					</Table.Column>
					<Table.Column span={5} className='py-2 pl-2 ml-10'>
						Check-in baggage
					</Table.Column>
					<Table.Column span={4} className='py-2 pl-3'>
						Cabin
						<br /> baggage
					</Table.Column>
					<Table.Column span={4} className='py-2 pl-3 ml-13'>
						Free date change if
						<br /> booking date is:
					</Table.Column>
					<Table.Column span={4} className='py-2 pl-3'>
						Free date change if
						<br /> travel date is:
					</Table.Column>
				</Table.Head>
			</Table>
			<Table>
				{airlinesList &&
					airlinesList.map((airline, index) => {
						return (
								<Table.Row
									className={classNames(
										'mx-0 py-1--xs c-default c-neutral-700 fs-3 br-4 bw-1 ba bc-neutral-100 mb-2  hover:bc-neutral-100  hover:c-neutral-700',
										{ 'hover:elevation-2 c-pointer': airline.airline_link }
									)}
									key={index}
								>
									<Table.Column xs={24} span={4} className='pt-4 pb-4 pl-4 flex flex-between fw-700'>
										<div className='flex flex-middle'>
											<span className='pr-3 flex flex-middle'>
												<img width='24' height='24' className='br-4' src={airline.logo_url} alt='airline-logo' />
											</span>
											<span>{airline.name}</span>
										</div>
									</Table.Column>

									<Table.Column xs={24} className='d-none d-block--xs c-neutral-400 pt-3  pl-3 px-4--xs pt-1--xs pb-1--xs'>
										Baggage limit
									</Table.Column>

									<Table.Column xs={24} className='pt-4 pb-4 pl-3 d-none d-block--xs px-4--xs pt-1--xs pb-1--xs'>
										{' '}
										<span className='pr-2'>Check-in baggage:</span>
										{airline.check_in_baggage}
									</Table.Column>
									<Table.Column xs={24} className='pt-4 pb-4 pl-3 d-none d-block--xs px-4--xs pt-1--xs pb-1--xs'>
										<span className='pr-2'>Cabin baggage:</span>
										{airline.cabin_baggage}
									</Table.Column>
									<Table.Column xs={24} className='flex flex-middle pt-4 pb-4 pl-3 pb-1--xs d-none d-block--xs px-4--xs'>
										<span className='pr-2'>Free date change if booking date is:</span>
										{airline.free_date_booking ? airline.free_date_booking : <>NA</>}
									</Table.Column>
									<Table.Column xs={24} className='flex flex-middle pt-4 pt-1--xs pb-4 pl-3  d-none d-block--xs px-4--xs'>
										<span className='pr-2'>Free date change if travel date is:</span>
										{airline.free_date_travel ? airline.free_date_travel : <>NA</>}
									</Table.Column>
									<Table.Column span={5} xs={24} className='pt-4 pb-4 pl-2 flex flex-middle d-none--xs px-4--xs ml-10'>
										{airline.check_in_baggage}
									</Table.Column>
									<Table.Column span={4} xs={24} className='pt-4 pb-4 pl-3 flex flex-middle d-none--xs px-4--xs'>
										{airline.cabin_baggage}
									</Table.Column>
									<Table.Column span={4} xs={24} className='pt-4 pb-4 pl-3 flex flex-middle d-none--xs px-4--xs ml-13'>
										{airline.free_date_booking ? airline.free_date_booking : <>NA</>}
 									</Table.Column>
									<Table.Column span={4} className='pt-4 pb-4 pl-3 flex flex-middle d-none--xs px-4--xs'>
										{airline.free_date_travel ? airline.free_date_travel : <>NA</>}
									</Table.Column>
								</Table.Row>
						);
					})}
			</Table>
			<div className='fs-2 c-neutral-400 pt-1'>
				*All airlines are expected to enable flexible policies in line with the earlier lockdown policies in case flights
				announced from May 25th get cancelled subsequently for any reason
			</div>
		</>
		)
	}

	return (
		<>
			<Table>
				<Table.Head className='bg-neutral-0 c-neutral-700 fs-2 mb-2 flex flex-middle d-none--xs'>
					<Table.Column span={4} className='py-2 pl-4'>
						Airline
					</Table.Column>
					<Table.Column span={4} className='py-2 pl-2'>
						Check-in baggage
					</Table.Column>
					<Table.Column span={3} className='py-2 pl-3'>
						Cabin
						<br /> baggage
					</Table.Column>
					<Table.Column span={3} className='py-2 pl-3'>
						Web
						<br /> check-in
					</Table.Column>
					<Table.Column span={2} className='py-2 pl-3'>
						Meals
						<br /> on flight
					</Table.Column>
					<Table.Column span={7} className='py-2 pl-3'>
						Policy for flights cancelled during COVID (March 25th-May 24th)*
					</Table.Column>
				</Table.Head>
			</Table>
			<Table>
				{airlinesList &&
					airlinesList.map((airline, index) => {
						return (
							<a
								href={airline.airline_link ? airline.airline_link : 'javascript:void(0)'}
								target={airline.airline_link && '_blank'}
								rel='noopener noreferrer'
								className='td-none'
							>
								<Table.Row
									className={classNames(
										'mx-0 py-1--xs c-default c-neutral-700 fs-3 br-4 bw-1 ba bc-neutral-100 mb-2  hover:bc-neutral-100  hover:c-neutral-700',
										{ 'hover:elevation-2 c-pointer': airline.airline_link }
									)}
									key={index}
								>
									<Table.Column xs={24} span={4} className='pt-4 pb-4 pl-4 flex flex-between fw-700'>
										<div className='flex flex-middle'>
											<span className='pr-3 flex flex-middle'>
												<img width='24' height='24' className='br-4' src={airline.logo_url} alt='airline-logo' />
											</span>
											<span>{airline.name}</span>
										</div>
										{airline.airline_link && (
											<span className='p-relative d-none d-block--xs'>
												<div className='flex'>
													<span className='chevron-text pr-1'>Details</span>
													<Chevron height={16} width={12} className='rotate-270 c-secondary-500' />
												</div>
											</span>
										)}
									</Table.Column>

									<Table.Column xs={24} className='d-none d-block--xs c-neutral-400 pt-3  pl-3 px-4--xs pt-1--xs pb-1--xs'>
										Baggage limit
									</Table.Column>

									<Table.Column xs={24} className='pt-4 pb-4 pl-3 d-none d-block--xs px-4--xs pt-1--xs pb-1--xs'>
										{' '}
										<span className='pr-2'>Check-in baggage:</span>
										{airline.check_in_baggage}
									</Table.Column>
									<Table.Column xs={24} className='pt-4 pb-4 pl-3 d-none d-block--xs px-4--xs pt-1--xs pb-1--xs'>
										<span className='pr-2'>Cabin baggage:</span>
										{airline.cabin_baggage}
									</Table.Column>
									<Table.Column xs={24} className='pt-4 pb-4 pl-3 pb-1--xs d-none d-block--xs px-4--xs'>
										{' '}
										<span className='pr-2'>Web check-in:</span>
										{airline.web_checkin}
									</Table.Column>
									<Table.Column xs={24} className='pt-4 pb-4 pl-3 d-none d-block--xs pt-1--xs px-4--xs flex flex-middle'>
										{' '}
										<span className='pr-2'>Meals in flight: </span>
										{airline.meals_on_flight === 'No' ? <Cross /> : <Tick className="c-success-500" />}
									</Table.Column>
									<Table.Column xs={24} className='pt-4 pb-4 pl-3 d-none d-block--xs  flex px-4--xs'>
										{' '}
										{airline.refund_policy} for flights cancelled during COVID (March 25-May 25)*
									</Table.Column>

									<Table.Column span={4} xs={24} className='pt-4 pb-4 pl-2 flex flex-middle d-none--xs px-4--xs'>
										{airline.check_in_baggage}
									</Table.Column>
									<Table.Column span={3} xs={24} className='pt-4 pb-4 pl-3 flex flex-middle d-none--xs px-4--xs'>
										{airline.cabin_baggage}
									</Table.Column>
									<Table.Column span={3} xs={24} className='pt-4 pb-4 pl-3 flex flex-middle d-none--xs px-4--xs'>
										{airline.web_checkin}
									</Table.Column>
									<Table.Column span={2} xs={24} className='pt-4 pb-4 pl-3 flex flex-middle d-none--xs px-4--xs'>
										{airline.meals_on_flight === 'No' ? <Cross /> : <Tick />}
									</Table.Column>
									<Table.Column span={6} className='pt-4 pb-4 pl-3 flex flex-middle d-none--xs px-4--xs'>
										{airline.refund_policy}
									</Table.Column>
									{airline.airline_link && (
										<Table.Column span={2} className='d-none--xs flex-end pr-7'>
											<Chevron height={16} width={12} className='ml-2 rotate-270 c-secondary-500' />
										</Table.Column>
									)}
								</Table.Row>
							</a>
						);
					})}
			</Table>
			<div className='fs-2 c-neutral-400 pt-1'>
				*All airlines are expected to enable flexible policies in line with the earlier lockdown policies in case flights
				announced from May 25th get cancelled subsequently for any reason
			</div>
		</>
	);
}

export default Airlines;
